var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 6.66943H22.6667C21.196 6.66943 20 7.86543 20 9.3361V13.3361H12V9.3361C12 7.86543 10.804 6.66943 9.33333 6.66943H6.66667C5.196 6.66943 4 7.86543 4 9.3361V20.0028C4 21.4734 5.196 22.6694 6.66667 22.6694H9.33333C10.804 22.6694 12 21.4734 12 20.0028V16.0028H20V20.0028C20 21.4734 21.196 22.6694 22.6667 22.6694H25.3333C26.804 22.6694 28 21.4734 28 20.0028V9.3361C28 7.86543 26.804 6.66943 25.3333 6.66943ZM6.66667 20.0028V9.3361H9.33333L9.33467 20.0028H6.66667ZM22.6667 20.0028V9.3361H25.3333L25.3347 20.0028H22.6667ZM29.3333 12.0028H32V17.3361H29.3333V12.0028ZM0 12.0028H2.66667V17.3361H0V12.0028Z",
    fill: "#00A32F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.0027,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory3);
export default __webpack_public_path__ + "static/media/category3.c43cbf9a445e91085028c3a097394ab4.svg";
export { ForwardRef as ReactComponent };